import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ProductCard from "../ProductCard/ProductCard";

const rubikfont = { fontFamily: "Rubik, sans-serif" };

// Layout 3: "Noir". A dark premium band with a centred gold heading and a compact grid.
const Layout3 = ({ data }) => {
    const products = (data?.product_id || []).slice(0, 12);
    const navigate = useNavigate();
    const viewAll = () => navigate(`/search?layoutId=${data._id}&title=${encodeURIComponent(data.title)}`);

    return (
        <Box sx={{ my: { xs: 1.5, md: 3 }, py: { xs: 3.5, md: 5 }, background: "radial-gradient(circle at 20% 0%, #2a2218 0%, #14110d 55%)" }}>
            <Container maxWidth="xl">
                <Box sx={{ textAlign: "center", mb: { xs: 2.5, md: 4 } }}>
                    <Typography sx={{ fontSize: "11px", fontWeight: 600, letterSpacing: "4px", color: "#C8A054", textTransform: "uppercase", mb: 1, ...rubikfont }}>
                        {data?.subtitle || "Exclusive Collection"}
                    </Typography>
                    <Typography sx={{ fontSize: { xs: "26px", sm: "36px" }, fontWeight: 800, color: "#fff", fontFamily: "'Playfair Display', serif", lineHeight: 1.1 }}>
                        {data?.title}
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5, mt: 1.5 }}>
                        <Box sx={{ width: 60, height: "1px", bgcolor: "rgba(200,160,84,0.6)" }} />
                        <Box sx={{ width: 7, height: 7, bgcolor: "#C8A054", transform: "rotate(45deg)" }} />
                        <Box sx={{ width: 60, height: "1px", bgcolor: "rgba(200,160,84,0.6)" }} />
                    </Box>
                </Box>

                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", sm: "repeat(3, minmax(0, 1fr))", md: "repeat(4, minmax(0, 1fr))", lg: "repeat(6, minmax(0, 1fr))" },
                        gap: { xs: 1.25, md: 2 },
                    }}
                >
                    {products.map((product) => (
                        <Box key={product._id}>
                            <ProductCard product={product} />
                        </Box>
                    ))}
                </Box>

                <Box sx={{ textAlign: "center", mt: { xs: 3, md: 4 } }}>
                    <Box
                        onClick={viewAll}
                        sx={{ display: "inline-block", px: 4, py: 1.1, borderRadius: "999px", border: "1px solid #C8A054", color: "#C8A054", fontSize: "12px", fontWeight: 600, letterSpacing: "2px", textTransform: "uppercase", cursor: "pointer", transition: "all .2s", "&:hover": { bgcolor: "#C8A054", color: "#14110d" }, ...rubikfont }}
                    >
                        View all
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Layout3;
